import * as React from 'react';

const FirstTrialContent = () => {
    return (
        <>
            <h4>
                ANZ 7801/2
            </h4>
            <p>
                The first BCT trials called ANZ 7801/2 start, which investigate the first line treatment of advanced breast cancer with chemotherapy, endocrine therapy (tamoxifen in postmenopausal women and oophorectomy in premenopausal women), and also combined chemotherapy and endocrine therapy. The studies found that patients treated with initial endocrine therapy had a similar survival and a superior quality of life whilst on that treatment, compared to those who received chemotherapy. BCT recruited 69 premenopausal women to ANZ 7801 and 339 postmenopausal women to ANZ 7802. Measurement of quality of life continues to be an important part of BCT trials. 
            </p>
        </>
    );
}

export default FirstTrialContent;